import { Fragment } from 'react'
import type { InsightEntity } from '@testfeed/shopify-contracts'
import { buildShopifyAdminEntityUrl } from '../../../shopify-admin-entity-url'
import { useAppBridge } from '@shopify/app-bridge-react'
import { trackShopifyAction } from '../../../shopifyUiTracking'

/** Labels come from the server; the host alone translates an explicit entity target to native navigation. */
export function InsightEntityNames({ entities, separator }: { entities: readonly InsightEntity[]; separator: string }) {
  const shopify = useAppBridge()
  return entities.map((entity, index) => {
    const href = entity.target ? buildShopifyAdminEntityUrl(entity.target) : null
    let name = <>{entity.label}</>
    if (href)
      name = (
        <s-link
          href={href}
          target="_top"
          onClick={() => trackShopifyAction(shopify, 'open-admin-entity', () => undefined)}
        >
          {entity.label}
        </s-link>
      )
    return (
      <Fragment key={entity.id}>
        {index > 0 ? separator : null}
        {name}
      </Fragment>
    )
  })
}
